//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SettingsNotifications from './SettingsNotifications/SettingsNotifications.vue';
import SettingsSystemNotifications from './SettingsSystemNotifications/SettingsSystemNotifications.vue';
import SettingsP2PNotifications from './SettingsP2PNotifications/SettingsP2PNotifications.vue';

export default {
  components: {
    SettingsNotifications,
    SettingsSystemNotifications,
    SettingsP2PNotifications,
  },
};
